import { render, staticRenderFns } from "./MakerK12.vue?vue&type=template&id=3001a2d3&scoped=true"
import script from "./MakerK12.vue?vue&type=script&lang=js"
export * from "./MakerK12.vue?vue&type=script&lang=js"
import style0 from "./MakerK12.vue?vue&type=style&index=0&id=3001a2d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3001a2d3",
  null
  
)

export default component.exports